import { render, staticRenderFns } from "./MatchExplicitActivityRows.vue?vue&type=template&id=89900d4c&"
import script from "./MatchExplicitActivityRows.vue?vue&type=script&lang=js&"
export * from "./MatchExplicitActivityRows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports